import React, { useState } from 'react';
import { Grid, LinearProgress, Snackbar, Typography } from '@mui/material';
import Alert from '@mui/material/Alert';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '../components/CustomButtons/Button';
import InfoIcon from '@mui/icons-material/Info';
import { formatCurrency } from '../utils';

const inputStyles = {
  padding: '8px',
  borderRadius: '4px',
  border: '1px solid #ccc',
  marginRight: '10px',
};

const InventorySearch = ({
  vendorOpportunityId,
  handleReloadEquipmentData,
  refetchDocs,
  inventoryActions,
  onSyncEquipment,
}) => {
  const [stockNumber, setStockNumber] = useState('');
  const [vin, setVin] = useState('');
  const [inventorySyncIsLoading, setInventorySyncIsLoading] = useState(false);
  const [successSnackbarOpen, setSuccessSnackbarOpen] = useState(false);
  const [failureSnackbarOpen, setFailureSnackbarOpen] = useState(false);

  const handleSearch = () => {
    if (stockNumber || vin) {
      inventoryActions.searchInventory({
        variables: {
          input: {
            stockNumber: stockNumber,
            vin: vin,
          },
        },
      });
    }
  };

  const handleSync = rowData => {
    setInventorySyncIsLoading(true);
    inventoryActions
      .syncInventory({
        variables: {
          vendorOpportunityId: vendorOpportunityId,
          vin: rowData.vin,
          stockNumber: rowData.stockNumber,
        },
        context: { authRequired: true },
      })
      .then(response => {
        try {
          if (response.data.syncInventoryItemToVo.success) {
            setSuccessSnackbarOpen(true);
            handleReloadEquipmentData();
          } else {
            setInventorySyncIsLoading(false);
            setFailureSnackbarOpen(true);
          }

          onSyncEquipment?.();
          //Reload documents
          if (refetchDocs) {
            refetchDocs();
          }
        } catch (e) {
          console.log(`Inventory sync error: ${e.message}`);
          setFailureSnackbarOpen(true);
          setInventorySyncIsLoading(false);
        }
      })
      .catch(e => {
        console.log(`Inventory sync error: ${e.message}`);
        setFailureSnackbarOpen(true);
        setInventorySyncIsLoading(false);
      });
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSuccessSnackbarOpen(false);
    setFailureSnackbarOpen(false);
  };

  return (
    <div>
      <input
        style={inputStyles}
        type="text"
        placeholder="Enter Stock Number"
        value={stockNumber}
        onChange={e => setStockNumber(e.target.value)}
        disabled={!inventoryActions?.hasAccessToInventorySearch}
      />
      <input
        style={inputStyles}
        type="text"
        placeholder="Enter VIN"
        value={vin}
        onChange={e => setVin(e.target.value)}
        disabled={!inventoryActions?.hasAccessToInventorySearch}
      />
      <Button
        color="primary"
        size="sm"
        variant="contained"
        onClick={handleSearch}
        disabled={!inventoryActions?.hasAccessToInventorySearch}
      >
        Search
      </Button>
      {!inventoryActions?.hasAccessToInventorySearch && (
        <Grid container>
          <Grid item style={{ display: 'flex', marginTop: 20 }}>
            <InfoIcon style={{ color: '#0c84fc', marginRight: 6 }} />
            <Typography>
              Contact your IT Department or Trnsact Account Manager to integrate your inventory feed
            </Typography>
          </Grid>
        </Grid>
      )}
      {(inventoryActions?.inventoryDataIsLoading || inventorySyncIsLoading) && (
        <div style={{ paddingTop: '16px', paddingBottom: '16px' }}>
          <LinearProgress size={48} />
        </div>
      )}
      {inventoryActions?.inventoryData &&
        inventoryActions?.inventoryData.inventorySearch &&
        !inventoryActions?.inventoryDataIsLoading &&
        !inventorySyncIsLoading && (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>VIN</TableCell>
                {/* <TableCell>Source</TableCell> */}
                <TableCell>Stock Number</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Year</TableCell>
                <TableCell>Make</TableCell>
                <TableCell>Model</TableCell>
                <TableCell>Mileage</TableCell>
                <TableCell>Condition</TableCell>
                <TableCell>Retail Price</TableCell>
                <TableCell>Sync</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {inventoryActions?.inventoryData.inventorySearch.map(item => (
                <TableRow key={item.vin}>
                  <TableCell>{item.vin}</TableCell>
                  {/* <TableCell>{item.source}</TableCell> */}
                  <TableCell>{item.stockNumber}</TableCell>
                  <TableCell>{item.description}</TableCell>
                  <TableCell>{item.year}</TableCell>
                  <TableCell>{item.make}</TableCell>
                  <TableCell>{item.model}</TableCell>
                  <TableCell>{item.mileage}</TableCell>
                  <TableCell>{item.condition}</TableCell>
                  <TableCell>{formatCurrency(item.retailPrice)}</TableCell>
                  <TableCell>
                    <Button variant="contained" color="primary" onClick={() => handleSync(item)}>
                      Sync
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      <Snackbar open={successSnackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar}>
        <Alert elevation={6} variant="filled" onClose={handleCloseSnackbar} severity="success">
          Success! Please wait...
        </Alert>
      </Snackbar>
      <Snackbar open={failureSnackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar}>
        <Alert elevation={6} variant="filled" onClose={handleCloseSnackbar} severity="error">
          Error: Please contact support
        </Alert>
      </Snackbar>
    </div>
  );
};

export default InventorySearch;
